"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const react_1 = require("@xstate/react");
const react_2 = __importDefault(require("react"));
const messages_1 = __importDefault(require("../../lib/messages"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const utils_1 = require("../../../lib/utils");
const styles_1 = require("../../../ManageAppointment/components/Confirmation/styles");
const SearchProviderButton_1 = __importDefault(require("../SearchProviderButton/SearchProviderButton"));
const Confirmation = ({ service }) => {
    var _a, _b, _c, _d, _e;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const [state] = (0, react_1.useService)(service);
    const { context } = state;
    const formattedAppointmentDate = (0, utils_1.getAppointmentDate)({ start_datetime: (_a = context.appointment) === null || _a === void 0 ? void 0 : _a.start_datetime }, 'MMMM DD, YYYY');
    const name = (_b = context.provider) === null || _b === void 0 ? void 0 : _b.name;
    const providerName = (0, utils_1.makeNameString)({
        first: (_c = name === null || name === void 0 ? void 0 : name.first) !== null && _c !== void 0 ? _c : '',
        last: (_d = name === null || name === void 0 ? void 0 : name.last) !== null && _d !== void 0 ? _d : '',
        middle: (_e = name === null || name === void 0 ? void 0 : name.middle) !== null && _e !== void 0 ? _e : ''
    });
    return (react_2.default.createElement(styles_1.StyledConfirmationContainer, { "data-testid": "confirmation-container", id: "print-reschedule-content", isAboveMd: aboveMd },
        react_2.default.createElement(styles_1.StyledConfirmationTitle, { "data-testid": "confirmation-title" },
            react_2.default.createElement(CheckCircle_1.default, { "aria-hidden": "true" }),
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.confirmPageHeading))),
        react_2.default.createElement(styles_1.StyledConfirmationBody, null,
            react_2.default.createElement(styles_1.StyledConfirmationDescription, { "data-testid": "confirmation-description" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.confirmPageDescription, { values: {
                        provider_name: providerName,
                        appointment_date: formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedDate,
                        appointment_time: formattedAppointmentDate === null || formattedAppointmentDate === void 0 ? void 0 : formattedAppointmentDate.formattedTime
                    } })))),
        aboveMd && react_2.default.createElement(SearchProviderButton_1.default, { service: service })));
};
exports.default = Confirmation;
//# sourceMappingURL=Confirmation.js.map